let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ffRiQ")).then(() => parcelRequire('3Hy6N'));